import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { fetchRoles } from '../../services/auth0Services'

export interface IRole {
    uuid: string
    roleName: string
    roleAuthId: string
}
interface RolesType {
    roles: IRole[]
}

const initialState: RolesType = {
    roles: [],
}

export const getRoles = createAsyncThunk('roles/getroles', async () => {
    const response: IRole[] = await fetchRoles()
    return response
})

const rolesSlice = createSlice({
    name: 'roles',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getRoles.fulfilled, (state, action) => {
            state.roles = action.payload
        })
    },
})

export default rolesSlice.reducer
